var mentions_default = {
  "mentionPalette": "OH61Y",
  "mention": "SjNRn",
  "mentionViewer": "z-URx",
  "mentionSuggestionsEntry": "_87z4h",
  "mentionSuggestionsEntryFocused": "-XY9E",
  "mentionSuggestionsEntryText": "TyXYl",
  "mentionSuggestionsEntryAvatar": "y8BRT",
  "mentionSuggestions": "yczXY",
  "cursorDefault": "tmTj-",
  "cursorPointer": "gPngf"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
